import React from "react";
import { TableCell, TableRow } from "@mui/material";
import moment from "moment";

const ContentDetailsStatusHistoryTableRow = ({ row, numberType, labelId }) => {
  return (
    <TableRow
      hover
      // onClick={(event) => handleClickRow(event, row.id)}
      role="checkbox"
      tabIndex={-1}
      key={row.id}
      sx={{
        cursor: "pointer",
        height: 30,
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      <TableCell
        // component="th"
        id={labelId}
        // scope="row"
        padding="none"
        style={tableCellStyles}
      >
        {row?.date && row?.date?.seconds
          ? moment.unix(row?.date?.seconds).format("MM-DD-YYYY HH:mm:ss")
          : moment(row.date).format("MM-DD-YYYY")}
      </TableCell>
      <TableCell
        align="left"
        padding="none"
        style={{
          ...tableCellStyles,
          color:
            row?.status == "reported"
              ? "#CC1F3E"
              : row?.status == "in review"
              ? "#E59A00"
              : row.status == "resolved"
              ? "#128D1F"
              : "#128D1F",
          textTransform: "capitalize",
        }}
      >
        {row?.status}
      </TableCell>
      <TableCell padding="none" align="left" style={tableCellStyles}>
        {row?.action}
      </TableCell>
      <TableCell padding="none" align="left" style={tableCellStyles}>
        {row?.notes}
      </TableCell>
      <TableCell padding="none" align="left" style={tableCellStyles}>
        {row?.updatedBy}
      </TableCell>
    </TableRow>
  );
};

export default ContentDetailsStatusHistoryTableRow;

const tableTitleFieldStyles = {
  border: "1px solid #BABABA",
  // paddingLeft: 5,
  color: "#00A7CD",
  fontWeight: 600,
  fontFamily: "Avenir Book, sans-serif",
};

const tableCellStyles = {
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
  paddingLeft: 10,
  height: 30,
};
// const tableStatusCellStyles = {
//   border: "1px solid #BABABA",
//   cursor: "pointer",

//   fontFamily: "Avenir Book, sans-serif",
//   // fontWeight: 600,
// };
